import React, { useEffect, useState, useContext } from "react";
import MenuHospital from "./navHospital/MenuHospital";
import * as hospitalApi from "../../service/hospitalApi";
import * as publicApi from "../../service/publicApi";
import PageHeader from "../pageheader/PageHeader";
import Input from "../material/input/Input";
import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline";
import { HashLoader } from "react-spinners";
import Button from "../material/button/Button";
import InputV2 from "../material/input/InputV2";

import { CurrentUserContext } from "../../App";
import styles from "./layouts.module.css";

const SetupHospital = () => {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);
  const [hospitalWebhook, setHospitalWebhook] = useState({
    hospital_name: "",
    hospital_id: "",
    ip_address: "",
    client_id: "",
    client_secret: "",
  });

  // const [formState, setFormState] = useState(
  //     {
  //         "hospital_id": "",
  //         "send": {
  //             "url": "",
  //             "header_list": [
  //                 {
  //                     "key": "",
  //                     "value": ""
  //                 }
  //             ]
  //         },
  //         "revoke": {
  //             "url": "",
  //             "header_list": [
  //                 {
  //                     "key": "",
  //                     "value": ""
  //                 }
  //             ]
  //         }
  //     }
  // )
  // const styles_tw = {
  //     container: 'mx-48 mt-[50px] md:mx-5',
  //     label_input: 'text-[#2E2E2E] font-bold underline my-[10px]',
  //     bg_card: 'bg-[#fff9e4] my-[20px] px-[50px] pt-[10px] pb-[20px] rounded-[20px]',
  //     line_storke: 'border border-solid border-[#A2B5BC] my-[20px]',
  //     btn_add: 'button-theme-pg bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl shadow-sm shadow-brand-cyan flex justify-center items-center text-[16px] h-[45px] w-[200px] gap-[10px] text-[#526F65] ',
  //     btn_save: 'button-theme-pg bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl shadow-sm shadow-brand-cyan flex justify-center items-center text-[16px] h-[45px] w-[150px] gap-[10px] text-[#526F65] ',
  //     grid_cols_three: '',
  //     icon_delete: 'button-theme-pg bg-[#EA8D8D] p-2 rounded-full stroke-[#374957] stroke-[3px] hover:cursor-pointer',

  // }

  useEffect(() => {
    getWebHookHospital();
  }, []);

  const getWebHookHospital = async () => {
    setLoading(true);
    let res = await hospitalApi.getHospitalWebHookHospital();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setHospitalWebhook({
          hospital_name: res["data"]["hospital_webhook"]["hospital_name"] ?? "",
          hospital_id: res["data"]["hospital_webhook"]["hospital_id"] ?? "",
          ip_address: res["data"]["hospital_webhook"]["ip_address"] ?? "",
          client_id: res["data"]["hospital_webhook"]["client_id"] ?? "",
          client_secret: res["data"]["hospital_webhook"]["client_secret"] ?? "",
        });
      } else {
        setHospitalWebhook({
          hospital_name: "",
          hospital_id: "",
          ip_address: "",
          client_id: "",
          client_secret: "",
        });
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "warning",
        data: res["data"]["message_th"] || res["data"]["message"],
      });
    }
  };

  // const saveWebHookHospital = async (formState) => {
  //     setLoading(true)
  //     let res = await hospitalApi.saveWebHookHospital(formState)
  //     setLoading(false)
  //     if (res) {
  //         if (res['data']['code'] === 200) {
  //             setIsMessage(res['data']['message_th'] || res['data']['message'])
  //         } else {
  //           setIsMessage(res['data']['message_th'] || res['data']['message'])
  //         }
  //     } else {
  //         setIsMessage(res['data']['message_th'] || res['data']['message'])
  //     }
  // }

  // const handleChangeInputURL = (type, e) => {

  //     const insertFormState = { ...formState[type] }
  //     if (type === 'send') {
  //         insertFormState[e.target.name] = e.target.value
  //         setFormState({
  //             ...formState, [type]: insertFormState
  //         });
  //     } else {
  //         insertFormState[e.target.name] = e.target.value
  //         setFormState({
  //             ...formState, [type]: insertFormState
  //         });
  //     }
  // }

  // const handleChangeInputHeader = (type, e, index) => {

  //     const insertFormState = { ...formState[type] }
  //     insertFormState['header_list'][index][e.target.name] = e.target.value
  //     setFormState({
  //         ...formState, [type]: insertFormState
  //     });
  // }

  // const addHeaderKey = (type) => {

  //     let newHeaderKey = {
  //         "key": "",
  //         "value": ""
  //     }
  //     const updatedFormState = { ...formState[type] };
  //     // console.log(updatedFormState)
  //     if (type === 'send') {
  //         updatedFormState['header_list'].push(newHeaderKey)

  //         setFormState({
  //             ...formState, send: updatedFormState
  //         })
  //     } else {
  //         updatedFormState['header_list'].push(newHeaderKey)

  //         setFormState({
  //             ...formState, revoke: updatedFormState
  //         })
  //     }
  // }

  // const removeHeader = (type, item_remove) => {
  //     const updatedFormState = { ...formState[type] };
  //     // console.log(updatedFormState, type)

  //     if (type === 'send') {
  //         updatedFormState['header_list'] = updatedFormState['header_list'].filter((remove) => {
  //             return remove !== item_remove
  //         })
  //         setFormState({
  //             ...formState, [type]: updatedFormState
  //         })
  //     } else {
  //         updatedFormState['header_list'] = updatedFormState['header_list'].filter((remove) => {
  //             return remove !== item_remove
  //         })
  //         setFormState({
  //             ...formState, [type]: updatedFormState
  //         })
  //     }
  // }

  // const hadleSubmit = (action) => {
  //     if (formState.send.url === '') {
  //         setIsMessage('กรุณากรอก URL สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล')
  //         return
  //     }
  //     for (let send_header_list of formState.send.header_list) {
  //         if (send_header_list['key'] === '') {
  //             setIsMessage('กรุณากรอก Key ให้ครบถ้วน')
  //             return
  //         }
  //         if (send_header_list['value'] === '') {
  //             setIsMessage('กรุณากรอก value ให้ครบถ้วน')
  //             return
  //         }
  //     }
  //     if (formState.revoke.url === '') {
  //         setIsMessage('กรุณากรอก URL สำหรับการเรียกคืนข้อมูลจากโรงพยาบาล')
  //         return
  //     }
  //     for (let revoke_header_list of formState.revoke.header_list) {
  //         if (revoke_header_list['key'] === '') {
  //             setIsMessage('กรุณากรอก Key ให้ครบถ้วน')
  //             return
  //         }
  //         if (revoke_header_list['value'] === '') {
  //             setIsMessage('กรุณากรอก value ให้ครบถ้วน')
  //             return
  //         }
  //     }
  //     saveWebHookHospital()
  // }

  // console.log(hospitalWebhook);

  return (
    <div className="flex flex-col w-full bg-[#ffffff]">
      <PageHeader titlename={"ตั้งค่าการแลกเปลี่ยนข้อมูลในโรงพยาบาล"} />
      <div className={`w-full`}>
        {/* <div
            className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
          >
            ตั้งค่าการแลกเปลี่ยนข้อมูลในโรงพยาบาล
          </div> */}
        {!loading ? (
          <div className="rounded-[6px] border-[#E2E2E4] border w-full min-w-[400px] p-[17px_16px]">
            <div className="flex flex-col text-[16px] font-['Prompt'] mb-[10px]">
              ชื่อโรงพยาบาล
              <InputV2
                type="text"
                className="border-1 border-solid border-[#E0DFE2] rounded-lg md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
                placeholder=""
                value={hospitalWebhook.hospital_name ?? "-"}
                disabled={true}
              />
            </div>
            <div className="flex flex-col text-[16px] font-['Prompt'] mb-[10px]">
              IP Address
              <InputV2
                type="text"
                className="border-1 border-solid border-[#E0DFE2] rounded-lg md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
                placeholder=""
                value={hospitalWebhook.ip_address ?? "-"}
                disabled={true}
              />
            </div>
            <div className="flex flex-col text-[16px] font-['Prompt'] mb-[10px]">
              Client ID
              <InputV2
                type="text"
                className="border-1 border-solid border-[#E0DFE2] rounded-lg md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
                placeholder=""
                value={hospitalWebhook.client_id ?? "-"}
                disabled={true}
              />
            </div>
            <div className="flex flex-col text-[16px] font-['Prompt'] mb-[10px]">
              Client Secret
              <InputV2
                type="text"
                className="border-1 border-solid border-[#E0DFE2] rounded-lg md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
                placeholder=""
                value={hospitalWebhook.client_secret ?? "-"}
                disabled={true}
              />
            </div>

            {/* <div className={styles_tw.bg_card}>
                <div className={styles_tw.label_input}>
                  URL สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล
                </div>
                <Input
                  placeholder="URL"
                  disabledLabel
                  name="url"
                  value={formState?.send?.url || ""}
                  validate={formState.send.url === "" ? true : false}
                  onChangeEvt={(e) => {
                    handleChangeInputURL("send", e);
                  }}
                />
                {formState["send"]["header_list"].map((i, indx) => {
                  return (
                    <>
                      <div className={styles_tw.line_storke}></div>
                      <div className={styles_tw.label_input}>Header</div>
                      <div className="grid grid-cols-[auto_auto_50px] gap-5 items-end">
                        <Input
                          placeholder="Key"
                          name="key"
                          value={i["key"]}
                          validate={i["key"] === "" ? true : false}
                          onChangeEvt={(e) => {
                            handleChangeInputHeader("send", e, indx);
                          }}
                        />
                        <Input
                          placeholder="Value"
                          name="value"
                          value={i["value"]}
                          validate={i["value"] === "" ? true : false}
                          onChangeEvt={(e) => {
                            handleChangeInputHeader("send", e, indx);
                          }}
                        />
                        {formState["send"]["header_list"].length !== 1 && (
                          <MinusIcon
                            className={styles_tw.icon_delete}
                            onClick={() => {
                              removeHeader("send", i);
                            }}
                          />
                        )}
                      </div>
                    </>
                  );
                })}
                <div className="flex justify-center items-center mt-[35px]">
                  <button
                    className={styles_tw.btn_add}
                    onClick={() => {
                      addHeaderKey("send");
                    }}
                  >
                    <PlusIcon className="stroke-[#526F65] stroke-[3px] w-[25px]" />
                    <div>เพิ่ม Header</div>
                  </button>
                </div>
              </div>

              <div className={styles_tw.bg_card}>
                <div className={styles_tw.label_input}>
                  URL สำหรับยกเลิกการรับ - ส่งข้อมูลไปยังโรงพยาบาล
                </div>
                <Input
                  placeholder="URL"
                  disabledLabel
                  name="url"
                  value={formState.revoke.url}
                  validate={formState.revoke.url === "" ? true : false}
                  onChangeEvt={(e) => {
                    handleChangeInputURL("revoke", e);
                  }}
                />
                {formState["revoke"]["header_list"].map((i, indx) => {
                  return (
                    <>
                      <div className={styles_tw.line_storke}></div>
                      <div className={styles_tw.label_input}>Header</div>
                      <div className="grid grid-cols-[auto_auto_50px] gap-5 items-end">
                        <Input
                          placeholder="Key"
                          name="key"
                          value={i["key"]}
                          validate={i["key"] === "" ? true : false}
                          onChangeEvt={(e) => {
                            handleChangeInputHeader("revoke", e, indx);
                          }}
                        />
                        <Input
                          placeholder="Value"
                          name="value"
                          value={i["value"]}
                          validate={i["value"] === "" ? true : false}
                          onChangeEvt={(e) => {
                            handleChangeInputHeader("revoke", e, indx);
                          }}
                        />
                        {formState["revoke"]["header_list"].length !== 1 && (
                          <MinusIcon
                            className={styles_tw.icon_delete}
                            onClick={() => {
                              removeHeader("revoke", i);
                            }}
                          />
                        )}
                      </div>
                    </>
                  );
                })}
                <div className="flex justify-center items-center mt-[35px]">
                  <button
                    className={styles_tw.btn_add}
                    onClick={() => {
                      addHeaderKey("revoke");
                    }}
                  >
                    <PlusIcon className="stroke-[#526F65] stroke-[3px] w-[25px]" />
                    <div>เพิ่ม Header</div>
                  </button>
                </div>
              </div>

              <div className="flex justify-center items-center mt-[35px]">
                <Button
                  style={{ width: "160px" }}
                  onClick={() => {
                    hadleSubmit();
                  }}
                >
                  บันทึก
                </Button>
              </div> */}
          </div>
        ) : (
          <HashLoader
            loading={true}
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "20px",
            }}
            color="#FF9768"
          />
        )}
      </div>
    </div>
  );
};
export default SetupHospital;
